const constants = {
  //ReTool Credentials
  DashboardLandingPageUUID:"64c3ff4e-d5fa-11ee-bb57-83a6126db139",
  MultiDashboardLandingPageUUID:"71309648-d5fa-11ee-942a-d37adf8294d0",
  DashboardLandingPageUUIDTabbed:"504475de-3929-11ef-abff-bb5b54b68785",
  MultiDashboardLandingPageUUIDTabbed:"2d8e0c9c-441b-11ef-8174-cfba81a96f10",
  RetoolGroupIds:[2634742],
  pageSize:25,
  supplierPageSize:250,
  BudgetpageSize:100,
  defaultSocialPagesize:96,
  defaultSocialConfigurePagesize:40,
  pageSizeBudgets:100,
  Email: "Email",
  Password: "Password",
  OTPPassword: "OTP",
  Login: "Log In",
  Continue:"Continue",
  LoginEmailValid:"Enter Email",
  LoginPasswordValid:"Enter Password",
  OTPValid:"Enter One Time Password",
  CreateNew:"Create New",
  SaveOrder:"Save Order",
  UploadHistoryList:["Last ", <strong key='upload-history'>30 day</strong> ," upload history"],
  ActivityLogLast90:["Last ", <strong key='upload-history'>90 days</strong> ," activity log"],
  BudgetLogLast90:["Last ", <strong key='upload-history'>90 days</strong> ," budget log"],
  JobsIndexed:"jobs indexed on Hire Intelligence",
  PriorityLevels:"Priority Levels:",
  UpdatePriorityLevels:"Update all selected jobs:",
  AppReportTab1:"Daily Report",
  AppReportTab2:"Month Report",
  AdminOrderCSTab1:"Orders",
  AdminOrderCSTab2:"Contracts",
  AdminOrderCSTab3:"Live Contracts",
  AppReportShortTab1:"Daily",
  AppReportShortTab2:"Month",
  AppReportTab3:"Occupation",
  AppReportTab4:"Occ. Matrix",
  AppReportTab5:"Spend/Job",
  AppReportTab6:"Apps Log",
  AppReportTab7:"Quality",
  AppReportTab8:"Int/Hires",
  AppReportTab9:"GAP Analysis",
  AppReportTab10:"Location",
  MultiBudgetsAdminTab1:"Budgets",
  MultiBudgetsAdminTab2:"Not Delivering",
  MultiBudgetsAdminTab3:"Over Budget",
  MultiApplicationReport1:"Month Report",
  MultiApplicationReport2:"Month Day Report",
  MultiApplicationReport4:"SUPPLIERS",
  Pause:"Pause",
  Paused:"Paused",
  UpdateBtn:"Update",
  DistributionTab1:"Occupation",
  DistributionTab2:"Priority Level",
  ChatBotTab1:"Chat - Apply for Jobs",
  ChatBotTab2:"Chat - Careers site",
  BudgetTab1:"Budgets",
  BudgetTab2:"Spend",
  AnalysisTab1:"AI Analysis",
  AnalysisTab2: "Automated Reports",
  AnalysisTab3: "Report History",
  BudgetTab5:"Contracts Spend",
  BudgetTab3:"Spend By Cost Center",
  BudgetTab4:"Budgets By Cost Center",
  BudgetsMsg:"Please contact your account manager to update JOBBOARD BUDGET",
  PriorityPopup:"Create new priority filter",
  PriorityRulesPopup: "Create new priority rules",
  supplierName:"Supplier Name",
  DownloadCV:"Download CV",
  Download:"Download",
  CreatOrder:"Create Order",
  BuyBoostCredits:"Buy Boost Credits",
  DownloadBySupplier:"Download By Supplier",
  SinglePostDetails:"Update Single Post Details",
  ActivityLogsTab1:"Priority Level",
  ActivityLogsTab2:"Distribution Rules",
  ActivityLogsTab3:"Budget",
  SocialMediaTab1:"Configure",
  SocialMediaTab2:"Published Ads",
  SocialMediaTab3:"Careers Site / Landing Pages",
  PostAllNewJobsTO:"POST ALL NEW JOBS TO",
  SelectBoosts: "SELECT BOOSTS",
  IfJobTitleContains:"IF JOB TITLE CONTAINS",
  SocialTab1: "Adverts",
  SocialTab2: "Reports",

  //Date Format
  DateFormat:"DD-MM-YYYY",
  DateFormat2:"YYYY-MM-DD",
  AmericanDateFormat:"MM-DD-YYYY",
  AmericanDateLongFormat:"MMM-DD-YYYY",
  MonthFormat:"MMM-YYYY",

  // Cookies
  COOKIE_EXPIRY_DAYS:3,
  COOKIE_TOKEN:'token',
  COOKIE_LOGGED_BUYER_ID:'loggedInBuyerId',
  COOKIE_LOGGED_BUYER_NAME:'loggedInBuyerName',
  COOKIE_LOGGED_BUYER_SELF_POSTED:'loggedInBuyerSelfPosted',
  COOKIE_SELECTED_BUYER_ID:'SelectedBuyerId',
  COOKIE_SELECTED_BUYER_NAME:'SelectedBuyerName',
  COOKIE_IS_ADMIN:"hireIntelligenceAdmin",
  COOKIE_IS_SUPERADMIN:"hireIntelligenceSuperAdmin",
  COOKIE_IS_CS_ADMIN:"hireIntelligenceCSAdmin",
  COOKIE_CANDIDATE_TAB:"hiHideCandidateTab ",
  COOKIE_SELECTED_IS_SUB_BUYER_ADMIN:"selectedSubBuyerAdmin",
  COOKIE_LOGGEDIN_IS_SUB_BUYER_ADMIN:"loggedInSubBuyerAdmin",
  COOKIE_SELECTED_BUYER_SELF_POSTED:"SelectedBuyerSelfPosted",
  COOKIE_SOCIAL_TOKEN:"SocialToken",
  COOKIE_PARSER_LINK:'parserLink',
  COOKIE_EMAIL_POST:"emailPost",
  COOKIE_CANDIDATE_SEARCH:"candidateSearch",
  COOKIE_CLICK_POST:"clickPost",
  COOKIE_IS_RECRUITER:"userRecruiter",
  COOKIE_IS_SELFSERVICE:"userService",
  COOKIE_IS_BOOST:"userBoost",
  COOKIE_IS_FINANCE:"isHiFinance",
  COOKIE_ALLOW_CREDIT_INVOICE:"allowCreditInvoice",
  COOKIE_HIRE_INTELLIGENCE_USER:"hireIntelligenceUser",
  
  // Messages
  ERROR_MESSAGE:"Something went wrong. Please try again later.",
  NO_DATA:"No data found.",
  SUCCESS_SAVE:"Data saved successfully.",
  FAILED_SAVE:"Failed to save data.",
  PRIORITY_FILTER_TEXT_ERROR:"Enter text in atleast one filter.",
  MANAGE_SUPPIER_INFO_MSG:"Please contact your account manager to add this supplier",
  CONTRACT_SPEND_INFO_MSG:"This page is used to assign spend for Job Board fixed term posting contracts to allow CPA/CPI/CPH to be calculated. If there is a tick for 'Use Last Months Budgets' on the Suppliers page the inputted value from last month will continue to be assigned each month until changed.",
  BOOST_JOB_AD_BUY_TEXT:"Important: By Clicking Book Now you will create an order and receive an invoice for all the above products.",
  BOOST_JOB_AD_BUY_TEXT_SELF_SERVICE_1:"Important: By Clicking Book Now you will create an order and the total will be deducted from your credit balance.",
  BOOST_JOB_AD_BUY_TEXT_SELF_SERVICE_2:"Important: You do not have enough credit balance to create this order please:",
  BOOST_JOB_AD_TERMS_MSG:"I am booking based on the terms set by Apply Gateway Ltd(Hire Intelligence) and I have read their ",
  FAILED_OTP:"Failed to send OTP.Try Again",
  SUCCESS_OTP_SENT:"OTP sent to registered Emaid ID.",
  FAILED_OTP_VERIFFY:"Enter valid OTP.",

  //SocialIDs for jobStatus
  AllJobsJS: 'alljobs',
  ActiveJS:'active',
  InActiveJS:'inactive',
  ErrorJS:'error',
  SpendingBudget:'Spending',
  SpentBudget:'Spent',
  NotLiveBudget:'Not Live',

  //spend conditions
  HasLessThan: 'Has less than',
  HasMoreThan: 'Has more than',

  //Currency
  CurrencyConstants:{
    "GBP":"£",
    "EUR":"€",
    "USD":"$"
  },

  //Priotity Rules and filters
  PrioritySubHeader1:"*THESE RULES CAN ONLY BE EDITED BY THE MASTER ACCOUNT.",
  PrioritySubHeader2:"*TO REMOVE THE INHERIT SETTING CONTACT YOUR ACCOUNT MANAGER.",

  //Priority constants
  PriorityConstantList1: [
      {
        value: 0,
        label: (
          <div className="w-3.5 h-3.5 border rounded-full border-black bg-white my-2"></div>
        ),
      },
      {
        value: 1,
        label: (
          <div className="w-3.5 h-3.5 border rounded-full border-black bg-lime-400 my-2"></div>
        ),
      },
      {
        value: 2,
        label: (
          <div className="w-3.5 h-3.5 border rounded-full border-black bg-orange-400 my-2"></div>
        ),
      },
      {
        value: 3,
        label: (
          <div className="w-3.5 h-3.5 border rounded-full border-black bg-red-600 my-2"></div>
        ),
      },
      {
        value: 4,
        label: (
          <div className="w-3.5 h-3.5 border rounded-full border-black bg-purple-600 my-2"></div>
        ),
      },
    ],
  PriorityConstantList2:[
    {
      value: 0,
      label: (
        <div className="w-3.5 h-3.5 border rounded-full border-black bg-white my-2"></div>
      ),
    },
    {
      value: 1,
      label: (
        <div className="w-3.5 h-3.5 border rounded-full border-black bg-lime-400 my-2"></div>
      ),
    },
    {
      value: 2,
      label: (
        <div className="w-3.5 h-3.5 border rounded-full border-black bg-green-900 my-2"></div>
      ),
    },
    {
      value: 3,
      label: (
        <div className="w-3.5 h-3.5 border rounded-full border-black bg-yellow-400 my-2"></div>
      ),
    },
    {
      value: 4,
      label: (
        <div className="w-3.5 h-3.5 border rounded-full border-black bg-orange-400 my-2"></div>
      ),
    },
    {
      value: 5,
      label: (
        <div className="w-3.5 h-3.5 border rounded-full border-black bg-red-600 my-2"></div>
      ),
    },
    {
      value: 6,
      label: (
        <div className="w-3.5 h-3.5 border rounded-full border-black bg-pink-600 my-2"></div>
      ),
    },
    {
      value: 7,
      label: (
        <div className="w-3.5 h-3.5 border rounded-full border-black bg-purple-600 my-2"></div>
      ),
    },
    {
      value: 8,
      label: (
        <div className="w-3.5 h-3.5 border rounded-full border-black bg-slate-900 my-2"></div>
      ),
    },
  ],

  //Salary display constants
  SalaryDisplayConstants:[
    {
      value: 'Hourly',
      label: 'Hourly',
    },
    {
      value: 'Daily',
      label: 'Daily',
    },
    {
      value: 'Weekly',
      label: 'Weekly',
    },
    {
      value: 'Monthly',
      label: 'Monthly',
    },
    {
      value: 'Annually',
      label: 'Annually',
    }
  ],

  //DASHBOARD
  //TOP LEVEL TABS
  JobsAppsSpendVisuals:"Jobs / Apps / Spend Analytics",
  JobsAppsSpendData:"Jobs / Apps / Spend Data",
  CostPerAppHire:"Cost Per App / Interview / Hire Analytics",
  Suppliers:"Supplier Analytics",
  Market:"Market Data",
  // ====================SPEND VISUALS===========================
  //SECOND LEVEL TABS
  AppsSpendByDateRange:"Apps / Spend By Date Range",
  AppsSpendThisMonth:"Apps / Spend This Month",
  JobsAppsSpendLast12Months:"Apps / Spend Overtime",
  //TAB KEYS FOR SPENDVISUALS CHARTS
  applications:"applications",
  applicationsBySupplier:"applicationsBySupplier",
  spend:"spend",
  applicationsThisMonth:"applicationsThisMonth",
  applicationsThisMonthBySupplier:"applicationsThisMonthBySupplier",
  spendPerDayThisMonth:"spendPerDayThisMonth",
  spendPerMonthLast24Months:"spendPerMonthLast24Months",
  applicationVolumeLast12Months:"applicationVolumeLast12Months",
  jobsPostedPerMonth:"jobsPostedPerMonth",
  budgetVsSpendThisMonth:"budgetVsSpendThisMonth",
  spendOfBudgetSoFarThisMonth:"spendOfBudgetSoFarThisMonth",
  //SPENDVISUALS
  Applications:"Applications",
  ApplicationsBySupplier:"Applications By Supplier",
  Spend:"Spend",
  ApplicationsThisMonth:"Applications By Day This Month",
  ApplicationsThisMonthBySupplier:"Applications This Month By Supplier",
  SpendPerDayThisMonth:"Spend Per Day This Month",
  SpendPerMonthLast24Months:"Spend Per Month Last 24 Months",
  ApplicationVolumeLast12Months:"Application Volume Last 12 Months",
  JobsPostedPerMonth:"Jobs Posted Per Month",
  BudgetVsSpendThisMonth:"Budget Vs Spend This Month",
  SpendOfBudgetSoFarThisMonth:"% Spend Of Budget So Far This Month",
  //TAB KEYS FOR SPENDDATA CHARTS
  liveJobsLowAppVolume:"liveJobsLowAppVolume",
  expiredJobsLowAppVolume:"expiredJobsLowAppVolume",
  liveJobTitlesLowAppVolume:"liveJobTitlesLowAppVolume",
  liveLocationsLowAppVolume:"liveLocationsLowAppVolume",
  expiredJobTitlesLowAppVolume:"expiredJobTitlesLowAppVolume",
  expiredLocationsLowAppVolume:"expiredLocationsLowAppVolume",
  liveJobsHighSpend:"liveJobsHighSpend",
  expiredJobsHighSpend:"expiredJobsHighSpend",
  liveJobTitlesHighSpend:"liveJobTitlesHighSpend",
  liveLocationsHighSpend:"liveLocationsHighSpend",
  expiredJobTitlesHighSpend:"expiredJobTitlesHighSpend",
  expiredLocationsHighSpend:"expiredLocationsHighSpend",
  // ==================================================================

  // ====================SPEND DATA====================================
  Days: [
    {
      value: 60,
      label: '60 Days',
    },
    {
      value: 90,
      label: '90 Days',
    },
    {
      value: 120,
      label: '120 Days',
    },
    {
      value: 180,
      label: '180 Days',
    },
    {
      value: 365,
      label: '365 Days',
    },
  ],
  LiveJobsLowAppVolume:"Live Jobs by City (Low Apps, Last 7 Days)",
  ExpiredJobsLowAppVolume:"Expired Jobs by City (Low Apps)",
  LiveJobTitlesLowAppVolume:"Live Jobs by Title (Low Apps, Last 7 Days)",
  LiveLocationsLowAppVolume:"Live Locations (Low Apps, Last 7 Days)",
  ExpiredJobTitlesLowAppVolume:"Expired Jobs by Title (Low Apps)",
  ExpiredLocationsLowAppVolume:"Expired Locations (Low Apps)",
  LiveJobsHighSpend:"Live Jobs by City (Highest Spend, Last 7 Days)",
  ExpiredJobsHighSpend:"Expired Jobs by City (Highest Spend)",
  LiveJobTitlesHighSpend:"Live Jobs by Title (Highest Spend, Last 7 Days)",
  LiveLocationsHighSpend:"Live Locations (Highest Spend, Last 7 Days)",
  ExpiredJobTitlesHighSpend:"Expired Jobs by Title (Highest Spend)",
  ExpiredLocationsHighSpend:"Expired Locations (Highest Spend)",
  // ==================================================================
  // ====================COSTPERAPP/HIRE===============================
  //TAB KEYS FOR COSTPERAPP/HIRE CHARTS
  cpabyJobTitle:"cpabyJobTitle",
  appVolumeByJobTitle:"appVolumeByJobTitle",
  cpiByJobTitle:"cpiByJobTitle",
  cphByJobTitle:"cphByJobTitle",
  cpabyOccupation:"cpabyOccupation",
  appVolumeByOccupation:"appVolumeByOccupation",
  costPerInterviewByOccupation:"costPerInterviewByOccupation",
  costPerHireByOccupation:"costPerHireByOccupation",

  CPAByJobTitle:"CPA by Job Title",
  AppVolumeByJobTitle:"App Volume by Job Title",
  CpiByJobTitle:"CPI by Job Title",
  CphByJobTitle:"CPH by Job Title",
  CPAByOccupation:"CPA by Occupation",
  AppVolumeByOccupation:"App Volume by Occupation",
  CostPerInterviewByOccupation:"Cost Per Interview by Occupation",
  CostPerHireByOccupation:"Cost Per Hire by Occupation",
  // ==================================================================

  // ====================SUPPLIERS=====================================
  //TAB KEYS FOR SUPPLIERS
  paidAppsBySupplierByOccupation:"paidAppsBySupplierByOccupation",
  cpaBySupplierByOccupation:"cpaBySupplierByOccupation",
  interviewsBySupplierByOccupation:"interviewsBySupplierByOccupation",
  cpiBySupplierByOccupation:"cpiBySupplierByOccupation",
  hiresBySupplierByOccupation:"hiresBySupplierByOccupation",
  cphBySupplierByOccupation:"cphBySupplierByOccupation",
  paidAppsByJobTitleByOccupation:"paidAppsByJobTitleByOccupation",
  cpaByJobTitleByOccupation:"cpaByJobTitleByOccupation",
  interviewsByJobTitleByOccupation:"interviewsByJobTitleByOccupation",
  cpiBySupplierByJobTitle:"cpiBySupplierByJobTitle",
  hiresBySupplierByJobTitle:"hiresBySupplierByJobTitle",
  cphBySupplierByJobTitle:"cphBySupplierByJobTitle",

  DateOfApplication:" - Date of Application",
  PaidAppsBySupplierByOccupation:"Paid Apps By Supplier By Occupation",
  CPABySupplierByOccupation:"CPA By Supplier By Occupation",
  InterviewsBySupplierByOccupation:"Interviews By Supplier By Occupation",
  CPIBySupplierByOccupation:"CPI By Supplier By Occupation",
  HiresBySupplierByOccupation:"Hires By Supplier By Occupation",
  CPHBySupplierByOccupation:"CPH By Supplier By Occupation",
  PaidAppsByJobTitleByOccupation:"Paid Apps By Job Title By Occupation",
  CPAByJobTitleByOccupation:"CPA By Job Title By Occupation",
  InterviewsByJobTitleByOccupation:"Interviews By Job Title By Occupation",
  CPIBySupplierByJobTitle:"CPI By Supplier By Job Title",
  HiresBySupplierByJobTitle:"Hires By Supplier By Job Title",
  CPHBySupplierByJobTitle:"CPH By Supplier By Job Title",
  GOOGLE_COLORS: [
    "#3366CC", "#DC3912", "#FF9900", "#109618", "#990099", "#0099C6", "#DD4477",
    "#66AA00", "#B82E2E", "#316395", "#994499", "#22AA99", "#AAAA11", "#6633CC", "#E67300",

    "#8B0000", "#006400", "#00008B", "#8B008B", "#FF1493", "#00CED1", "#FFD700",
    "#7FFF00", "#FF4500", "#2E8B57", "#1E90FF", "#DA70D6", "#B8860B", "#20B2AA",

    "#FF6347", "#4682B4", "#9ACD32", "#FF69B4", "#CD5C5C", "#4B0082", "#00FA9A",
    "#6495ED", "#DC143C", "#00BFFF", "#8FBC8F", "#FF8C00", "#9932CC", "#3CB371",

    "#F08080", "#87CEFA", "#32CD32", "#BA55D3", "#FFA07A", "#7B68EE", "#00FF7F",
    "#6A5ACD", "#40E0D0", "#FF7F50", "#ADFF2F", "#FFB6C1", "#5F9EA0", "#FFDAB9"
  ],
  // ==================================================================
  // =========================MARKET===================================
  AverageCPAByOccupation:"Average Cost Per Application by Occupation",
  AverageCPIByOccupation:"Average Cost Per Interview and Hire by Occupation",
  // ==================================================================

  //==========================MULTI DASHBOARD==============================
  // ====================SPEND VISUALS===========================
  //TAB KEYS FOR SPENDVISUALS CHARTS
  applicationsByCostCenter:"applicationsByCostCenter",
  appsThisMonthBySupplier:"appsThisMonthBySupplier",
  cpabyOccupationLast90Days:"cpabyOccupationLast90Days",
  applicationsByOccupation:"applicationsByOccupation",
  applicationsByCostCenterWithDays:"applicationsByCostCenterWithDays",
  totalApplicationByCostCenter:"totalApplicationByCostCenter",
  totalSpendByCostCenter:"totalSpendByCostCenter",
  jobPostingsByCostCenter:"jobPostingsByCostCenter",
  liveJobsPerCostCenter:"liveJobsPerCostCenter",
  expiredJobsInLastXDaysPerCostCenter:"expiredJobsInLastXDaysPerCostCenter",
  
  ApplicationsByCostCenter:"Applications By Cost Center",
  AppsThisMonthBySupplier:"Apps This Month By Supplier",
  CpabyOccupationLast90Days:"CPA by Occupation (Last 90 Days)",
  ApplicationsByOccupation:"Applications By Occupation",
  TotalApplicationByCostCenter:"Total Application By Cost Center",
  TotalSpendByCostCenter:"Total Spend By Cost Center",
  JobPostingsByCostCenter:"Job Postings By Cost Center",
  LiveJobsPerCostCenter:"Live Jobs Per Cost Center",
  ExpiredJobsInLastXDaysPerCostCenter:"Expired Jobs Per Cost Center",
  DaysExtended : [
    { value: 7, label: '7 Days' },
    { value: 14, label: '14 Days' },
    { value: 30, label: '30 Days' },
    { value: 60, label: '60 Days' },
    { value: 90, label: '90 Days' },
    { value: 120, label: '120 Days' },
    { value: 180, label: '180 Days' },
    { value: 365, label: '365 Days' },
    { value: 730, label: '730 Days' },
  ],
  // ========================================================================
  // ==============================SUPPLIERS=================================
  paidAppsBySupplierByJobTitle:"paidAppsBySupplierByJobTitle",
  cpaBySupplierByJobTitle:"cpaBySupplierByJobTitle",
  interviewsBySupplierByJobTitle:"interviewsBySupplierByJobTitle",

  PaidAppsBySupplierByJobTitle: "Paid Apps By Supplier By Job Title",
  CPABySupplierByJobTitle: "CPA By Supplier By Job Title",
  InterviewsBySupplierByJobTitle: "Interviews By Supplier By Job Title",
  // ========================================================================
  Instructions:"Instructions",
  // ===============================WELCOME PAGE========================================
  WelcomeSuccessText:"Thank you! We have received your request. We will contact you regarding this product as soon as possible.",
}
export default constants;
